import { Dispatch, SetStateAction } from 'react';
import { OrderDataProps } from 'screens/OrderScreen';

import { HiMinus, HiPlus } from 'react-icons/hi';

type StartOrderProps = {
  orderData: OrderDataProps;
  setOrderData: Dispatch<SetStateAction<OrderDataProps>>;
};

const StartOrder = ({ orderData, setOrderData }: StartOrderProps) => {
  const handleCheckBox = () => {
    setOrderData({
      ...orderData,
      aditionalPages: orderData.aditionalPages > 0 ? 0 : 1,
    });
  };

  const addPages = () => {
    setOrderData({
      ...orderData,
      aditionalPages: orderData.aditionalPages + 1,
    });
  };

  const removePages = () => {
    setOrderData({
      ...orderData,
      aditionalPages: orderData.aditionalPages - 1,
    });
  };

  return (
    <div className="px-4 pt-6 pb-[150px] lg:mt-10 lg:px-0 lg:pt-0 lg:pb-0">
      <div className="lg:max-w-[95%] lg:rounded-2xl lg:p-8 lg:shadow-order">
        <p className="text-base font-semibold text-primary-black lg:text-base">
          Let’s get started!
        </p>
        <div className="mt-4 flex items-start rounded-xl border border-[#CFD8E2] p-5 lg:p-6">
          <input
            type="checkbox"
            className="h-[18px] w-[18px] checked:bg-black"
            checked={true}
            readOnly
          />
          <div className="ml-3">
            <p className="text-sm font-semibold text-primary-black lg:text-base">
              Landing page
            </p>
            <p className="mt-1.5 text-xs lg:text-sm">
              Single page website with up to 6 subsections customized to your
              content such as About Us, Our Services, Our Team, Contact Us, etc.
            </p>
            <p className="mt-2 text-[10px] text-[#9FA6B0] lg:text-xs">
              Up to 1000 words and 8 images. Includes 2 revisions
            </p>
            <div className="my-3 border-b border-[#E3E8ED]" />
            <p className="text-sm font-bold text-primary-black">₣2000</p>
          </div>
        </div>

        <p className="mt-8 text-base font-semibold text-primary-black lg:text-base">
          Need more pages?
        </p>

        <div className="mt-4 flex items-start rounded-xl border border-[#CFD8E2] p-5 lg:p-6">
          <input
            onChange={handleCheckBox}
            type="checkbox"
            className="h-[18px] w-[18px] checked:bg-black"
            checked={orderData.aditionalPages > 0}
          />
          <div className="ml-3">
            <p className="text-sm font-semibold text-primary-black lg:text-base">
              Additional pages
            </p>
            <p className="mt-1.5 text-xs lg:text-sm">
              Add more pages to your website for dedicated content instead of
              subsections.
            </p>
            <p className="mt-2 text-[10px] text-[#9FA6B0] lg:text-xs">
              Up to 500 words and 5 images for each page
            </p>
            <div className="my-3 border-b border-[#E3E8ED]" />
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <p className="text-sm font-bold text-primary-black">₣200</p>
                <p className="ml-1 text-xs text-primary-black">per page</p>
              </div>
              <div className="flex items-center">
                <button
                  className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-light-blue"
                  onClick={removePages}
                  disabled={orderData.aditionalPages <= 0}
                >
                  <HiMinus color="#FFF" />
                </button>
                <p className="bg-[#F2F9FF] px-3 py-1 text-xs font-semibold text-primary-black">
                  {orderData.aditionalPages}
                </p>
                <button
                  className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-light-blue"
                  onClick={addPages}
                >
                  <HiPlus color="#FFF" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartOrder;
